import React from 'react'
import {encryptStorage} from "./storage";
import Pokemon from "../data/pokemon.json";

class Const extends React.Component {


    static pokedexbyLang(props) {

        const savedPokemon = encryptStorage.getItem('pokemonNorm', false);


        const userLang = props.lang


        if (!savedPokemon || !savedPokemon.hasOwnProperty(userLang) || props.mode === 1) {
            return null;
        }

        return savedPokemon
            [userLang]?.map((item) => {
            const pokemon = Pokemon.find(x => x?.id === item)
            return {
                id: pokemon.id,              // ID field
                gen: pokemon.gen,
                name: pokemon['names'][userLang] // Dynamic language-based field
            };
        })
    }
}


export default Const